import { Box } from "@mui/material"
import { useParams } from "react-router"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { AmendsBoundaryEditor } from "./amends-boundary-editor"
import { createDraftId } from "../../lib/project-utils"
import { useAmendCollapse } from "./use-amend-collapse"

export function AmendsBoundaryTaskEditor() {
    const { task, target, editMode, amendsContext, getTaskAmendsKey } = useBoundContext()
    const { projectId, scheduleId } = useParams()
    const draftId = createDraftId(projectId, scheduleId)
    const { isCollapsed, onToggleCollapsed } = useAmendCollapse(draftId)

    if (!amendsContext) {
        throw new Error("AmendsBoundaryTaskEditor requires amendsContext")
    }
    if (!getTaskAmendsKey) {
        throw new Error("AmendsBoundaryTaskEditor requires getTaskAmendsKey")
    }

    const contextTarget = target ?? task
    const amendsKey = getTaskAmendsKey(contextTarget)
    const isOpen = amendsKey ? amendsContext.getAmendsState(amendsKey).isOpen : false

    if (!editMode || !amendsKey || !isOpen) return null

    return (
        <Box sx={{ pl: { xs: 2, sm: 5 }, pr: 2, pb: 2, pt: 1 }} data-cy="task-amends-editor">
            <AmendsBoundaryEditor
                amendsKey={amendsKey}
                subtitle="Change Task Reason"
                isCollapsed={isCollapsed}
                onToggleCollapsed={onToggleCollapsed}
                collapsible
            />
        </Box>
    )
}
